import React, { useCallback, useEffect, useState } from 'react';

import { useSelector } from 'react-redux';

import { useNavigation } from '@react-navigation/native';
import { StackNavigationProp } from '@react-navigation/stack';

import { SCREEN } from 'router/screens';
import { RouteNavigationParams } from 'router/types';

import { PurchaseProduct } from 'store/railsBuilder/reducer.types';
import {
    selectIfCollectionSuspensionActive,
    selectPurchaseCapability,
} from 'store/user/selectors';
import { isCapabilityValid } from 'store/utils';

import { isWeb } from 'utils/responsiveness';

import DetailVodHighUsageRestriction from 'screens/DetailVodHighUsageRestriction';

/**
 * Will navigate to separate page SCREEN.DETAILS_VOD_HIGH_USAGE_RESTRICTION for web,
 * and will return error dialog component for mobile.
 * @param rentOptions
 */
function useVodHighUsageRestriction(
    rentOptions: PurchaseProduct[] | undefined,
) {
    const navigation =
        useNavigation<
            StackNavigationProp<RouteNavigationParams, SCREEN.DETAILS>
        >();

    const collectionSuspensionActive = useSelector(
        selectIfCollectionSuspensionActive,
    );
    const purchaseCapability = useSelector(selectPurchaseCapability);

    const [restricted, setRestricted] = useState<boolean | undefined>(
        undefined,
    );

    const handleCloseError = useCallback(() => {
        setRestricted(false);
    }, []);

    useEffect(() => {
        if (
            restricted === undefined &&
            !isCapabilityValid(purchaseCapability) &&
            !collectionSuspensionActive &&
            rentOptions?.length
        ) {
            setRestricted(true);
        }
    }, [purchaseCapability, collectionSuspensionActive]);

    useEffect(() => {
        if (restricted && isWeb) {
            navigation.push(SCREEN.DETAILS_VOD_HIGH_USAGE_RESTRICTION);
        }
    }, [restricted]);

    if (!isWeb && restricted) {
        return <DetailVodHighUsageRestriction onClose={handleCloseError} />;
    }

    return undefined;
}

export default useVodHighUsageRestriction;
